import { z } from 'zod';
import { PasswordRegex } from '@msdyn365-commerce-modules/retail-actions';

export const getLoyaltySchema = (localeString: string, enableSignUp: boolean) => {
    const isEnUS = localeString === 'en-us';

    const baseSchema = z.object({
        country: z.string().optional(),
        email: z.string().email(),
        phone_number: isEnUS
            ? z
                  .string()
                  .min(4)
                  .max(16)
            : z.string().optional(),
        marketing: z.boolean().optional(),
        profiling: z.boolean().optional(),
        thirdparty: z.boolean().optional(),
        birthday: z.string().optional(),
        bday: z
            .string()
            .max(10)
            .optional(),
        postal_code: z
            .string()
            .max(9)
            .optional()
    });

    if (!enableSignUp) {
        return baseSchema;
    }

    return baseSchema.extend({
        name: z.string().min(1),
        lastname: z.string().min(1),
        password: z
            .string()
            .regex(PasswordRegex.defaultRegex)
            .regex(/^[^\p{Sc}]*$/u)
    });
};
